import { render, staticRenderFns } from "./PrizeList.vue?vue&type=template&id=686de41f&"
import script from "./PrizeList.vue?vue&type=script&lang=js&"
export * from "./PrizeList.vue?vue&type=script&lang=js&"
import style0 from "./PrizeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports